module.exports = __webpack_public_path__ + "static/media/scale.9de76f3b.png";